<template>
  <el-dialog
    title="发票信息填写："
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="160px" v-if="dialogVisible">
      <el-form-item>
        <div style="margin: 20px 0">
          <el-divider content-position="left">发票信息</el-divider>
        </div>
      </el-form-item>
      <el-form-item label="抬头类型">
        <el-radio-group v-model="form.headerTypeLabel" @change="invoiceTypeChange">
          <el-radio border label="个人/非企业单位"></el-radio>
          <el-radio border label="企业单位"></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="form.headerType == 2" label="纳税人识别号" prop="taxNo">
        <el-input v-model="form.taxNo" show-word-limit maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="发票抬头" prop="name">
        <el-input v-model="form.name" show-word-limit maxlength="80"></el-input>
      </el-form-item>
      <el-form-item label="发票金额">
        <el-input v-model="form.amount" disabled></el-input>
      </el-form-item>
      <el-form-item :label="form.headerType == 2 ? '注册地址' : '地址'">
        <el-input v-model="form.invoiceAdress" show-word-limit maxlength="100"></el-input>
      </el-form-item>
      <el-form-item :label="form.headerType == 2 ? '注册电话' : '电话'" prop="invoicePhone">
        <el-input v-model="form.invoicePhone" show-word-limit maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="开户银行">
        <el-input v-model="form.invoiceBank" show-word-limit maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="开户银行账号">
        <el-input v-model="form.invoiceBankNo" show-word-limit maxlength="50"></el-input>
      </el-form-item>
      <el-form-item>
        <div style="margin: 20px 0">
          <el-divider content-position="left">发票接收方式(至少选择一项)</el-divider>
        </div>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="form.phone" show-word-limit maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="mailbox">
        <el-input v-model="form.mailbox" show-word-limit maxlength="50"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submit">开票</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { validation } from '@/util/validation';
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        feePayIds: '',
        taxNo: '',
        amount: '',
        phone: '',
        name: '',
        mailbox: '',
        invoiceAdress: '',
        invoicePhone: '',
        invoiceBank: '',
        invoiceBankNo: '',
        headerTypeLabel: '企业单位', //抬头类型label
        headerType: 2, //抬头类型:1-个人;2-企业
      },
      rules: {
        name: [
          { required: true, message: '请输入发票抬头', trigger: 'blur' },
          { min: 1, max: 100, message: '输入长度应小于100个字符', trigger: 'change' },
        ],
        taxNo: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { validator: validation.taxNo(), message: '格式错误', trigger: 'blur' },
        ],
         invoicePhone: [
          {
            pattern: /^1\d{10}$|^(\d{3,4}-)?\d{7,8}(-\d{1,4})?$/,
            message: '格式错误',
            trigger: ['change', 'blur'],
          },
        ],
      },
      debounce: false,
    };
  },
  methods: {
    //父组件调用
    openDialog(params) {
      this.$set(this.form, 'amount', params.shouldAmount);
      this.form.feePayIds = params.id;

      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    invoiceTypeChange() {
      this.form.headerType = this.form.headerTypeLabel == '企业单位' ? 2 : 1;
    },
    submit() {
      if (this.debounce == true) return;
      this.debounce = true;
      this.$refs.form
        .validate()
        .then((res) => {
          if (!(this.form.mailbox || this.form.phone)) {
            this.$message({
              message: '请至少选择一个发票接收方式',
              type: 'warning',
            });
            this.debounce = false;
            return;
          }
          if (this.form.mailbox) {
            let temp = /^(\w+)(\.\w+)*@(\w+)(\.\w+)*.(\w+)$/i.test(
              this.form.mailbox
            );
            if (!temp) {
              this.$message({
                message: '邮箱格式错误',
                type: 'warning',
              });
              this.debounce = false;
              return;
            }
          }
          if (this.form.phone) {
            let tempRes = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(this.form.phone);
            if (!tempRes) {
              this.$message({
                message: '手机格式错误',
                type: 'warning',
              });
              this.debounce = false;
              return;
            }
          }
          if (this.form.headerType == 1) {
            this.form.taxNo = '';
          }
          //发票展示信息1 bankNo: invoiceBank + "-" +  invoiceBankNo
          //发票展示信息2 address: invoicePhone + "-" +  invoiceAdress
          this.form.bankNo = this.form.invoiceBank + '-' + this.form.invoiceBankNo;
          this.form.address = this.form.invoiceAdress+ '-' + this.form.invoicePhone;
          this.$emit('submit', this.form, () => {
            this.debounce = false;
            this.dialogVisible = false;
          });
        })
        .catch((err) => {
          this.debounce = false;
          console.log('参数校验失败==>',err);
        });
    },
  },
  created() {},
};
</script>

<style>
</style>